import { defineMessages } from 'react-intl'

export default defineMessages({
  notesHeadline: {
    id: 'app.notes.headline',
    defaultMessage: 'Notes',
  },
  notesPlaceholderNote: {
    id: 'app.notes.placeholderNote',
    defaultMessage: 'Leave a note',
  },
  notesValidationNote: {
    id: 'app.notes.validationNote',
    defaultMessage: 'Note is required!',
  },
})
